import React from 'react';
import { ShowAt } from 'consts/breakpoints';
import BuildingPermitTable from './BuildingPermitTable';
import { Title, Wrapper } from './styled';
import { BuildingPermitSummary as BuildingPermitSummaryTypes } from './types';
import { useLocale } from 'locale';
import { WithContentSlotSidePaddingContainer } from 'ds/components/Layout';

const WIDGET_DESKTOP_TABLE_ROWS = 8;
const WIDGET_MOBILE_TABLE_ROWS = 5;

interface BuildingPermitSummaryProps {
  data: BuildingPermitSummaryTypes;
}

const BuildingPermitSummary: React.FC<BuildingPermitSummaryProps> = ({ data }) => {
  const { t } = useLocale();
  return (
    <Wrapper>
      <WithContentSlotSidePaddingContainer>
        <Title>{t('widget.buildingPermit.summary', { address: null })}</Title>
        <ShowAt at={1}>
          {matches => (
            <BuildingPermitTable
              isMobile={matches}
              data={data.requests}
              visibleRowsDesktop={WIDGET_DESKTOP_TABLE_ROWS}
              visibleRowsMobile={WIDGET_MOBILE_TABLE_ROWS}
              paginationType={matches ? 'infinite' : 'pages'}
            />
          )}
        </ShowAt>
      </WithContentSlotSidePaddingContainer>
    </Wrapper>
  );
};

export default BuildingPermitSummary;
